import CitySEOHead from "@/components/feature/CitySEOHead";
import BossierCityHeroSection from "./components/HeroSection";
import BossierCityStickyNav from "./components/StickyNav";
import BossierCityProcessingTimeSection from "./components/ProcessingTimeSection";
import BossierCityServicesSection from "./components/ServicesSection";
import BossierCityLocalAreaSection from "./components/LocalAreaSection";
import BossierCityTestimonialsSection from "./components/TestimonialsSection";
import BossierCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BossierCityComparisonSection from "./components/ComparisonSection";
import BossierCityMistakesSection from "./components/MistakesSection";
import BossierCityHowItWorksSection from "./components/HowItWorksSection";
import BossierCityFAQSection, { faqs } from "./components/FAQSection";
import BossierCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BossierCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import BossierCityTravelTimingSection from "./components/TravelTimingSection";
import BossierCityDestinationsSection from "./components/DestinationsSection";

const pageTitle = "Emergency Passport Bossier City, LA — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Bossier City, LA — as fast as 24 hours. Serving Barksdale AFB military families, casino industry professionals, and Bossier Parish residents. A+ BBB rated, registered State Dept. courier.";

export default function BossierCityPage() {
  return (
    <>
      <CitySEOHead
        city="Bossier City"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/bossier-city"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bossier City, Louisiana"
        geoPosition="32.5160;-93.7321"
        keywords="expedited passport Bossier City, emergency passport Bossier City LA, Barksdale AFB passport, fast passport Louisiana, passport renewal Bossier City, Bossier Parish passport"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Bossier City travelers with immediate departure needs — as fast as 24 hours for Barksdale AFB families and Bossier Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Bossier City with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Bossier City and Shreveport-Bossier metro families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Bossier City, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Bossier Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Bossier City residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for Barksdale AFB personnel and casino industry professionals from Bossier City." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
        lastModified="2026-06-09"
        serviceAreaDesc="Emergency and expedited passport services for Bossier City, Barksdale AFB, and the Shreveport-Bossier metro."
      />

      <div className="font-sans">
        <BossierCityHeroSection />
        <BossierCityStickyNav />
        <BossierCityProcessingTimeSection />
        <BossierCityLocalAreaSection />
        <BossierCityServicesSection />
        <BossierCityTravelTimingSection />
        <BossierCityDestinationsSection />
        <BossierCityTestimonialsSection />
        <BossierCityAcceptanceFacilitiesSection />
        <BossierCityComparisonSection />
        <BossierCityMistakesSection />
        <BossierCityHowItWorksSection />
        <BossierCityFAQSection />
        <BossierCityHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/bossier-city" state="LA" />
        <BossierCityFinalCTA />
      </div>
    </>
  );
}